/*global navigator, localStorage */

const langmap = {
    nn: 'nb',
    pt: 'pt-br',
};

const getLocale = (manifest, sessions, userId) => {
    const languagePreferences = [];
    if (sessions) {
        for (let i = 0, l = sessions.length; i < l; i += 1) {
            const session = sessions[i];
            const language = session.language;
            if (session.userId === userId) {
                languagePreferences.unshift(language);
            } else {
                languagePreferences.push(language);
            }
        }
    }

    try {
        const appLanguage = localStorage.getItem('preferences.language');
        if (appLanguage) {
            languagePreferences.push(appLanguage);
        }
    } catch (error) {}

    const browserLanguage = navigator.language || navigator.userLanguage || '';
    if (browserLanguage) {
        languagePreferences.push(browserLanguage.toLowerCase());
    }

    const getFile = (language) => {
        const entry = manifest[`/locale/${language}.js`];
        if (entry) {
            return entry.file;
        }
        return null;
    };

    for (let i = 0, l = languagePreferences.length; i < l; i += 1) {
        let language = languagePreferences[i];
        language = langmap[language] || language;
        // Check if a non region-specific localisation for the language
        // exists if no specific one.
        const file = getFile(language) || getFile(language.slice(0, 2));
        if (file) {
            return file;
        }
    }
    return getFile('en');
};

// ---

export { getLocale };
